import { gql } from "@/services/httpAdapter";

// Common fragments
import {
	AddedCompensationFragment,
	CallActivityPerformanceFragment,
	ChargebacksFragment,
	CompensationFragment,
	EmployeeFragment,
	LongevityFragment,
	ReviewFragment,
	SalesPerformanceFragment,
} from "@/Washouts/api/common/fragments";

export function getOnCreateSalesAssociateWashout() {
	return gql`
		subscription onNewSalesWashoutAvailable($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onNewSalesWashoutAvailable(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				commissionCycleId
				payPeriodId
				userId
				created
				overdraw
				employee {
					...Employee
				}
				salesPerformance {
					...SalesPerformance
				}
				carryOver {
					sales {
						_id
						saleDate
						dealNumber
						customerName
						customerNumber
						salesManagerId
						salesManagerName
						stockNumber
						description
						saleType
						dealType
						adjustable
						frontGrossProfit
						backGrossProfit
						units
						saleAmount
						vehicleInformation {
							make
							model
							modelYear
							trim
						}
						frontProducts {
							_id
							product
							value
						}
						backProducts {
							_id
							product
							value
						}
						frontCommission
						backCommission
						grossCommission
						funded
						external
						origin {
							icon
							tooltip
						}
					}
					totals {
						totalsTypeTitle
						frontGrossProfit
						backGrossProfit
						frontProducts {
							_id
							product
							total
						}
						backProducts {
							_id
							product
							total
						}
						frontCommission
						backCommission
						grossCommission
						units
					}
				}
				salesLog {
					sales {
						_id
						saleDate
						dealStatus
						customerName
						financeManagerName
						dealNumber
						dealManagerName
						stockNumber
						saleType
						frontGrossProfit
						backGrossProfit
						units
						frontProducts {
							product
							value
						}
						backProducts {
							product
							value
						}
					}
					totals {
						frontGrossProfit
						backGrossProfit
						frontProducts {
							product
							total
						}
						backProducts {
							product
							total
						}
						units
					}
				}
				callActivityPerformance {
					...WashoutCallActivityPerformance
				}
				newChargebacks {
					...Chargebacks
				}
				preOwnedChargebacks {
					...Chargebacks
				}
				deductions {
					deductions {
						_id
						title
						value
					}
					total
				}
				birdDogs {
					birdDogs {
						_id
						date
						customer
						amount
						stockNumber
					}
					total
				}
				spiffs {
					spiffs {
						_id
						date
						spiffName
						amount
						stocksNumbers
					}
					total
				}
				autoAlerts {
					autoAlerts {
						_id
						date
						customer
						amount
						stockNumber
						saleType
					}
					total
				}
				customerSatisfactionIndex {
					totalReviews
					isPresent
					makes {
						_id
						make
						requiredReviews
						penetration
					}
				}
				longevity {
					...Longevity
				}
				review {
					...Review
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
			}
		}
		${AddedCompensationFragment}
		${CallActivityPerformanceFragment}
		${ChargebacksFragment}
		${CompensationFragment}
		${EmployeeFragment}
		${LongevityFragment}
		${ReviewFragment}
		${SalesPerformanceFragment}
	`;
}

export function getOnUpdateSalesAssociateWashout() {
	return gql`
		subscription onUpdateSalesWashout($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onUpdateSalesWashout(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				commissionCycleId
				payPeriodId
				userId
				review {
					...Review
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
			}
		}
		${AddedCompensationFragment}
		${CompensationFragment}
		${ReviewFragment}
	`;
}

export function getOnUpdateSalesAssociateWashoutStatus() {
	return gql`
		subscription onUpdateSalesWashoutStatus($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onUpdateSalesWashoutStatus(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				commissionCycleId
				payPeriodId
				userId
				position
				status
				employee {
					position
				}
				review {
					...Review
				}
			}
		}
		${ReviewFragment}
	`;
}
